import { render, staticRenderFns } from "./ReligionDelete.vue?vue&type=template&id=0743ea3c&"
import script from "./ReligionDelete.vue?vue&type=script&lang=js&"
export * from "./ReligionDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports